import { render, staticRenderFns } from "./trainFindPassword.vue?vue&type=template&id=78a55409&scoped=true&"
import script from "./trainFindPassword.vue?vue&type=script&lang=ts&"
export * from "./trainFindPassword.vue?vue&type=script&lang=ts&"
import style0 from "./trainFindPassword.vue?vue&type=style&index=0&id=78a55409&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a55409",
  null
  
)

export default component.exports